import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Tooltip from 'LuxKit/Tooltip'
import Clickable from 'components/Common/Clickable'
import Group from 'components/utils/Group'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import type { ChangeEvent } from 'react'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const InfoButton = styled(Clickable)`
  display: flex;
  align-items: center;
  justify-content: center;
`

interface Props {
  checked: boolean
  disabled?: boolean
  size?: 'small' | 'medium'
  onChange: (checked: boolean) => void
}

function LuxPlusRenewalPointsCheckbox(props: Props) {
  const { checked, disabled, onChange, size = 'small' } = props
  const intl = useIntl()

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.currentTarget.checked)
  }, [onChange])

  const description = intl.formatMessage({
    id: 'Ce8rEuZJgHm5_Sgu8dEj',
    defaultMessage: 'We’ll use your points first and charge any remaining amount to your renewal card.',
    description: 'Helper text under the LuxPlus renewal points checkbox explaining points are used before the card is charged',
  })

  return <Group direction="horizontal" gap={8} verticalAlign="center">
    <CheckboxInput
      size={size}
      checked={checked}
      disabled={disabled}
      onChange={handleChange}
      name="pay_lux_plus_renewal_with_points"
      data-testid="pay-lux-plus-renewal-with-points"
    >
      {intl.formatMessage({
        id: 'BJbtxnXXa17Qnx_oUF_x',
        defaultMessage: 'Use Société Points for {programName} renewal',
        description: 'Checkbox label letting a member opt in to paying their LuxPlus membership renewal with Société points',
      }, { programName: LUXURY_PLUS.PROGRAM_NAME })}
    </CheckboxInput>
    <Tooltip description={description}>
      <InfoButton aria-label={description}>
        <LineInfoCircleIcon size="XS" />
      </InfoButton>
    </Tooltip>
  </Group>
}

export default LuxPlusRenewalPointsCheckbox
